export type SupportedLanguage = 'en' | 'de';

export function normalizeLanguage(language?: string | null): SupportedLanguage {
  const raw = String(language || '').trim().toLowerCase();
  return raw.startsWith('de') ? 'de' : 'en';
}
